import { createSelector } from '@ngrx/store';

import { selectAuthState } from '../core.state';
import { AuthState } from './auth.reducer';

// export const selectAccessToken = createSelector(
//   selectAuthState,
//   (state: AuthState) => state.authResult ? state.authResult.accessToken : null
// );

export const selectLoggedUser = createSelector(
  selectAuthState,
  (state: AuthState) => state.loggedUser
);


// export const getSelectedLanguageCode = createSelector(
//   selectAuthState,
//   (state) => state.selectedLanguageCode
// );

export const selectInformationAgreementShowPopup = createSelector(
  selectAuthState,
  (state) => state.showInformationAgreementPopup
);
